module.exports = __webpack_public_path__ + "img/sudungnangluc-headline.9917b522.png";